<template>
    <div class="form-group col-12 ">
        <table class="table table-striped ">
            <thead>
                <tr>
                    <th scope="col">Problema</th>
                    <th scope="col">Segmento</th>
                    <th scope="col">Criticidade</th>
                    <th scope="col">Serviço Padrão</th>
                    <th scope="col">SLA</th>
                    <th scope="col">Ações</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(segmento, index) in segmentos" :key="index">
                    <td>{{ segmento.ds_conjunto }}</td>
                    <td>{{ segmento.ds_grupo }}</td>
                    <td>{{ segmento.ds_criticidade }}</td>
                    <td>{{ segmento.ds_item }}</td>
                    <td>{{ segmento.hr_sla }}</td>
                    <th scope="row d-flex" style="display: flex!important;">
                        <button class="btn btn-warning mr-2" @click="editarSegmento(segmento.nr_sequencial)">
                            <svg xmlns="http://www.w3.org/2000/svg" height="0.875em" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z"/></svg></button>
                        <button class="btn btn-danger" @click="excluirAgendamento(segmento)">
                            <svg xmlns="http://www.w3.org/2000/svg" height="0.875em" viewBox="0 0 448 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"/></svg></button>
                    </th>
                </tr>
            </tbody>
        </table>
    </div>
</template>


<script>
/* eslint-disable */
export default {
    name: 'NovaOsComponent',
    data() {
        return {
            form: {}
        }
    },

    created() {
        this.$store.dispatch('os/getSegmentos')
    },

    computed: {
        segmentos() {
            return this.$store.getters['os/getSegmentos']
        },
    },

    methods: {
        editarSegmento(segmento) {
            this.$store.dispatch('os/pesquisarSegmento', { data: segmento }).then(response => {
                this.$emit('setSegmento', { ...response.data[0] })
            })
        }
    }
}
</script>

<style scoped>
* {
    font-family: poppins;
    font-weight: 300;
}

.tab-content {
    background: #f7f7f7;
    box-shadow: -3px 4px 11px -7px #000 !important;
    border-radius: 20px;
}

thead th {
    font-weight: 4000;
}
</style>